export default {
    COUPON_TYPE_NO_COUPON: '1',
    COUPON_TYPE_SPECIFIC: '2'
}


// WEBPACK FOOTER //
// ./src/view/constant/salesrule/CouponTypeConstant.js